module.exports = __webpack_public_path__ + "img/schmelz-sidepunkte.d1370a97.png";